import { injectGlobal } from 'styled-components';
import { fontWeight } from 'seedling/constants';

export function injectDescriptionTheme(props = {}) {
  const customRules = Object.keys(props).map(k => `${k}: ${props[k]};`);

  injectGlobal`
    .tippy-tooltip.information-theme {
      background-color: white;
      box-shadow: 0 1px 15px rgba(0, 0, 0, .2);
      ${fontWeight('normal')}
      padding: 0;
      text-align: left;
      ${customRules.join('\n')}
    }

    .tippy-tooltip.information-theme .tippy-tooltip-content {
      padding: 10px 15px;
      color: black;
    }

    .tippy-tooltip.information-theme [x-circle] {
      background-color: white;
    }

    [x-placement^="bottom"] .tippy-tooltip.information-theme > [x-arrow] {
      border-color: white transparent;
    }
    [x-placement^="top"] .tippy-tooltip.information-theme > [x-arrow] {
      border-color: white transparent;
    }
    [x-placement^="left"] .tippy-tooltip.information-theme > [x-arrow] {
      border-color: transparent white;
    }
    [x-placement^="right"] .tippy-tooltip.information-theme > [x-arrow] {
      border-color: transparent white;
    }
  `;
}
